import { FC, useContext } from 'react';
import { get } from 'lodash';
import classnames from 'classnames';
import { DateRangePicker, TableContext } from './';
import styles from './AllFiltersDrawer.module.css';
type ChangeHandler = ({
  value: string
}) => void;
interface DateRangeFilterProps {
  columnId?: string;
  isQuickFilter?: false;
  onChange: ChangeHandler;
  value: string;
}
interface DateRangeQuickFilterProps {
  columnId: string;
  isQuickFilter: true;
  onChange?: undefined;
  value?: string;
}
export const DateRangeFilter: FC<DateRangeFilterProps | DateRangeQuickFilterProps> = ({
  columnId,
  isQuickFilter = false,
  onChange,
  value
}) => {
  const isDrawerFilter = !isQuickFilter;
  const {
    filterInfo,
    updateFilter
  } = useContext(TableContext);
  const handleQuickFilterChange = ({
    value
  }) => updateFilter({
    columnId: columnId as string,
    value
  });
  const thisFilter = filterInfo.find(filter => filter.columnId === columnId) as {
    columnName: string;
    value: string;
  };
  const handleChange = isQuickFilter ? handleQuickFilterChange : onChange as ChangeHandler;
  const valueToUse = isQuickFilter ? thisFilter.value : value as string;
  const componentProps = {
    size: isQuickFilter ? 'sm' : 'md',
    ...(isQuickFilter ? {
      borderColor: 'cloud.600'
    } : {})
  };
  const tooltipContent = isQuickFilter ? get(thisFilter, 'quickFilterTooltipContent', null) : null;
  return <div className={classnames({
    [styles.filterComponent]: isDrawerFilter
  })} data-sentry-component="DateRangeFilter" data-sentry-source-file="DateRangeFilter.tsx">
      {isDrawerFilter && <span className={styles.filterLabel}>{thisFilter.columnName}</span>}
      <DateRangePicker componentProps={componentProps} onChange={handleChange} tooltipContent={tooltipContent} value={valueToUse} data-sentry-element="DateRangePicker" data-sentry-source-file="DateRangeFilter.tsx" />
    </div>;
};